"use strict";

const NewsFormCtrl = function (CRUDService, Notification, config, $stateParams, $rootScope, $http, $state) {
    var ctrl = this;

    var initModel =  {
      title: "",
      content: "",
      publishDate: null,
      author: null
    };
    ctrl.model = $stateParams.item || initModel;

    ctrl.save = function(form){
      if (form.$valid){
        // get user uri
        $http.get(config.urls.users + "/search/findByUuid?uuid=" + $rootScope.user.uuid)
          .then(function(response){
            ctrl.model.author = response.data._links.self.href;
            if (!ctrl.model._links){
              ctrl.model.publishDate = new Date();
            }

            CRUDService.save(ctrl.model, config.urls.news).then(function(){
              ctrl.model = initModel;
              $state.go('main.settings.news');
            }, function(){
              Notification.error('Beim Speichern der Daten ist ein Fehler aufgetreten.');
            });
          });
      }
    };
  };

NewsFormCtrl.$inject = ['CRUDService', 'Notification', 'config', '$stateParams', '$rootScope', '$http', '$state'];

module.exports = {
  template: require('./news-form.html'),
  controller: NewsFormCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/form-news/form-news.component.js